import { render } from "./CartTotalsProductTitle.vue?vue&type=template&id=0cb84b78"
import script from "./CartTotalsProductTitle.vue?vue&type=script&lang=js"
export * from "./CartTotalsProductTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__